import React, { Component } from "react";
import { translate } from "../Services/translation";

export const AccordionPanel = (props) => props;
export const AccordionTabs = (props) => props;
export class Accordion extends Component {
  constructor(props) {
    super(props);
    const { index = -1 } = props;
    this.state = {
      index,
    };
  }
  handleClick(e, index) {
    this.setState((prevState, props) => ({
      ...prevState,
      index: index === prevState.index ? -1 : index,
    }));
  }
  handleClose() {
  
    this.setState({ index: -1 });
  }

  render() {
    const accordions = React.Children.toArray(this.props.children);
    const activeClass = (index) => (this.state.index === index ? "active" : "");
    const headers = accordions.map((accordion, index) => (
      <div className="columns" key={`accordion__header-${index}`}>
        <div className={`accordion__header ${activeClass(index)} ${accordion.props.icon || ""}`} onClick={(e) => this.handleClick(e, index)}>
          {accordion.props.header || ""}
        </div>
      </div>
    ));
    const panels = accordions.map((accordion, index) => (
      <div className={`accordion__panel ${activeClass(index)}`} key={`accordion__panel-${index}`}>
        <span className="close-accordion" onClick={(e) => this.handleClick(e, index)}>
          <svg>
            <use href="/ui/images/sprites/be-group.svg#close"></use>
          </svg>
        </span>
        {accordion.props.children}
        <div className="fixed-button">
          <button
            className="button button--orange"
            onClick={(event) => {
              this.handleClose();
              this.props.onSubmit(this.props.facetFilters);
            }}
          >
            {translate("filter.saveandclose")}
          </button>
        </div>
      </div>
    ));
    return (
      <div className={this.props.className}>
        <nav className={`accordion__header-container`}>{headers}</nav>
        {panels}
      
      </div>
    );
  }
}
